// Dashboard.js - หน้า Dashboard พร้อมการแบ่งหน้า (Pagination) และแสดง Token + API URL

import React, { useEffect, useState } from "react";

const ITEMS_PER_PAGE = 10;

const Dashboard = () => {
    const [logs, setLogs] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [token, setToken] = useState(null);

    const apiUrl = "https://affiliate-project.onrender.com/api/affiliate/packages"; // API URL
    const logsApiUrl = "https://affiliate-project.onrender.com/api/affiliate/logs"; // API logs URL
    const websitesApiUrl = "https://affiliate-project.onrender.com/api/get-websites"; // API get websites URL

    useEffect(() => {
        const storedToken = localStorage.getItem("access_token");
        if (storedToken) {
            setToken(storedToken);  // Set token if available
        }

        fetch("https://affiliate-project.onrender.com/api/affiliate/logs")
            .then((res) => {
                if (!res.ok) throw new Error("ไม่สามารถโหลดข้อมูล log ได้");
                return res.json();
            })
            .then((data) => setLogs(data.reverse())) // ✅ เรียงล่าสุดไว้ก่อน
            .catch((err) => setError(err.message))
            .finally(() => setLoading(false));
    }, []);

    const totalPages = Math.ceil(logs.length / ITEMS_PER_PAGE);
    const paginatedLogs = logs.slice(
        (currentPage - 1) * ITEMS_PER_PAGE,
        currentPage * ITEMS_PER_PAGE
    );

    const changePage = (page) => {
        if (page >= 1 && page <= totalPages) setCurrentPage(page);
    };

    // ฟังก์ชันสำหรับคัดลอก
    const handleCopy = (text) => {
        navigator.clipboard.writeText(text);
        alert("คัดลอกแล้ว: " + text);
    };

    // สร้างฟังก์ชันเพื่อให้แสดง token สั้นลง
    const shortenToken = (token) => {
        if (token.length > 20) {
            return token.slice(0, 20) + " ... " + token.slice(-10);
        }
        return token;
    };

    return (
        <div className="container py-5">
            <h2 className="fw-bold text-center mb-4">📊 รายการ Log การคลิกแพ็กเกจ</h2>

            {error && (
                <div className="alert alert-danger text-center">{error}</div>
            )}

            {loading ? (
                <div className="text-center">⏳ กำลังโหลดข้อมูล...</div>
            ) : (
                <>
                    {/* เพิ่ม Token และ API URL ใน Card */}
                    <div className="row mb-4">
                        {/* แสดง Token */}
                        {token && (
                            <div className="col-md-6">
                                <div className="card p-3">
                                    <h5>Token ของคุณ</h5>
                                    <p>{shortenToken(token)}</p> {/* แสดง token สั้นลง */}
                                    <button
                                        onClick={() => handleCopy(token)}
                                        className="btn btn-sm btn-primary mt-2"
                                    >
                                        คัดลอก Token
                                    </button>
                                </div>
                            </div>
                        )}

                        {/* แสดง API URL */}
                        <div className="col-md-6">
                            <div className="card p-3">
                                <h5>API Packages URL</h5>
                                <p>{apiUrl}</p>
                                <button
                                    onClick={() => handleCopy(apiUrl)}
                                    className="btn btn-sm btn-primary mt-2"
                                >
                                    คัดลอก API URL
                                </button>
                            </div>
                        </div>

                        {/* แสดง Logs API URL */}
                        <div className="col-md-6">
                            <div className="card p-3">
                                <h5>API Logs URL</h5>
                                <p>{logsApiUrl}</p>
                                <button
                                    onClick={() => handleCopy(logsApiUrl)}
                                    className="btn btn-sm btn-primary mt-2"
                                >
                                    คัดลอก API URL
                                </button>
                            </div>
                        </div>

                        {/* แสดง Get Websites API URL */}
                        <div className="col-md-6">
                            <div className="card p-3">
                                <h5>API Get Websites URL</h5>
                                <p>{websitesApiUrl}</p>
                                <button
                                    onClick={() => handleCopy(websitesApiUrl)}
                                    className="btn btn-sm btn-primary mt-2"
                                >
                                    คัดลอก API URL
                                </button>
                            </div>
                        </div>
                    </div>

                    {/* แสดงข้อมูล log */}
                    <div className="table-responsive mb-4">
                        <table className="table table-striped table-bordered align-middle">
                            <thead className="table-light text-center">
                                <tr>
                                    <th>#</th>
                                    <th>Affiliate</th>
                                    <th>Package</th>
                                    <th>เวลาคลิก</th>
                                </tr>
                            </thead>
                            <tbody>
                                {paginatedLogs.map((log, idx) => (
                                    <tr key={idx}>
                                        <td className="text-center">
                                            {(currentPage - 1) * ITEMS_PER_PAGE + idx + 1}
                                        </td>
                                        <td>{log.user}</td>
                                        <td>{log.package}</td>
                                        <td className="text-nowrap">
                                            {new Date(log.timestamp).toLocaleString("th-TH", {
                                                dateStyle: "short",
                                                timeStyle: "medium",
                                            })}
                                        </td>
                                    </tr>
                                ))}
                                {paginatedLogs.length === 0 && (
                                    <tr>
                                        <td colSpan="4" className="text-center text-muted">
                                            ไม่มีรายการคลิกในระบบ
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>

                    {/* Pagination */}
                    <div className="d-flex justify-content-center">
                        <nav>
                            <ul className="pagination">
                                <li className={`page-item ${currentPage === 1 && "disabled"}`}>
                                    <button className="page-link" onClick={() => changePage(currentPage - 1)}>
                                        ก่อนหน้า
                                    </button>
                                </li>
                                {[...Array(totalPages)].map((_, i) => (
                                    <li
                                        key={i}
                                        className={`page-item ${currentPage === i + 1 ? "active" : ""}`}
                                    >
                                        <button className="page-link" onClick={() => changePage(i + 1)}>
                                            {i + 1}
                                        </button>
                                    </li>
                                ))}
                                <li className={`page-item ${currentPage === totalPages && "disabled"}`}>
                                    <button className="page-link" onClick={() => changePage(currentPage + 1)}>
                                        ถัดไป
                                    </button>
                                </li>
                            </ul>
                        </nav>
                    </div>
                </>
            )}
        </div>
    );
};

export default Dashboard;
